import { Flex } from "@chakra-ui/react";
import ReusableText from "../../UI/ReusableText";
import ReusableForm from "./ReusableForm";
import { useState } from "react";
import { useEffect } from "react";

export default function Attendance({ setAttendance }) {
  const [response, setResponse] = useState({
    comesEarly: 0,
  });

  useEffect(() => {
    setAttendance(() => [response]);
  }, [response]);

  return (
    <Flex w="100%" align="start" direction="column">
      <Flex w="100%" height="55px" align="center" borderLeft="1px solid #ccc">
        <ReusableText
          text="ATTENDANCE & 
          PUNCTUALITY (5%)"
          color="#7F7E7E"
          weight="bold"
          size={{ lg: "12px", md: "10px", base: "6px" }}
          height="55px"
          w="10%"
          align="start"
          p="0.4rem"
        />
        <Flex height="55px" w="90%" align="start" direction="column">
          <ReusableForm
            onChange={(e) =>
              setResponse({ ...response, comesEarly: e.target.value })
            }
            title="Comes to work on time and can be relied upon to work 
          overtime when necessary "
          />
        </Flex>
      </Flex>
      <Flex w="100%" height="40px" align="center">
        <ReusableText
          text="Total"
          color="#7F7E7E"
          weight="bold"
          size={{ lg: "14px", md: "10px", base: "6px" }}
          w="10%"
          align="start"
          p="0.4rem"
          height="40px"
        />
        <Flex w="90%" height="40px" border="1px solid #ccc"></Flex>
      </Flex>
    </Flex>
  );
}
